import { render, staticRenderFns } from "./model1Swiper2.vue?vue&type=template&id=00373070&scoped=true"
import script from "./model1Swiper2.vue?vue&type=script&lang=js"
export * from "./model1Swiper2.vue?vue&type=script&lang=js"
import style0 from "./model1Swiper2.vue?vue&type=style&index=0&id=00373070&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00373070",
  null
  
)

export default component.exports